import React from 'react'
import styled from 'styled-components'
import Ficha from './ficha'
import { COLOR_TYPES } from '../constantes/colores.ts'
import { BOTONES } from '../constantes/enums.ts'
import { ICON_TYPES } from '../constantes/iconos.ts'
import foto1 from '../imagenes/IMG_20250306_143204.jpg'
import { useNavigate } from 'react-router-dom'

const Callgaleria = () => {
    const navigate = useNavigate()
    return (
        <Section>
            <Container>
                <Foto src={foto1} rotacion='45deg' />
                <Foto src={foto1} rotacion='0' />
                <Foto src={foto1} rotacion='-45deg' />
            </Container>
            <Ficha navegar='/Galeria' color={COLOR_TYPES.PRIMARY} texto='VISITA NUESTRA GALERIA' tipo={BOTONES.BOTON} icono={ICON_TYPES.GALERIA} />
        </Section>
    )
}

const Section = styled.section`
    background-color: var(--secundary);
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    gap: 50px;
    padding: 15px;
`

const Container = styled.div`
    padding: 40px 0;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    gap: 10px;
    perspective: 1000px;

`

const Foto = styled.img`
    height: 200px;
    width: 20vw;
    box-shadow: 4px 4px 10px #000;
    border-radius: 20px;
    flex-shrink: 1;
    transform: rotateY(${props => props.rotacion})
`

export default Callgaleria